import { useState } from 'react'

import useApiPost from 'Pods/Shared/Hooks/useApiPost'

export default function useReplies(initialReplies, productId, ratingId) {
  const { postData, isLoading } = useApiPost()

  const [state, setState] = useState({
    localReplies: initialReplies,
    replyContent: '',
    showReplyForm: false,
  })

  const setReplyContent = (value) => {
    setState(prev => ({ ...prev, replyContent: value }))
  }

  const setShowReplyForm = (value) => {
    setState(prev => ({ ...prev, showReplyForm: value }))
  }

  const handleReplySubmit = (currentUsername, currentUserAvatar) => {
    if (!state.replyContent.trim()) return

    const optimisticReply = {
      id: Date.now(),
      content: state.replyContent,
      username: currentUsername || 'Anonymous',
      avatar: currentUserAvatar || { small: { url: null } },
      updatedAt: new Date().toISOString(),
    }

    setState(prev => ({
      ...prev,
      localReplies: [...prev.localReplies, optimisticReply],
    }))

    postData({
      path: '/api/internal/comments',
      data: {
        commentable_type: 'Item',
        commentable_id: productId,
        content: state.replyContent,
        parent_id: ratingId,
      },
      onSuccess: () => {
        window.showNotification('Reply posted successfully', { type: 'success' })
        setState(prev => ({
          ...prev,
          replyContent: '',
          showReplyForm: false,
        }))
      },
      onError: () => {
        setState(prev => ({
          ...prev,
          localReplies: initialReplies,
        }))
        window.showNotification('Failed to post reply', { type: 'error' })
      },
    })
  }

  return {
    localReplies: state.localReplies,
    replyContent: state.replyContent,
    setReplyContent,
    showReplyForm: state.showReplyForm,
    setShowReplyForm,
    handleReplySubmit,
    isLoading,
  }
}
